module.exports = __webpack_public_path__ + "3cdb9fbff3f83d6c266efa8ea4ad7415.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/scan-barcode.svg
// module id = 778
// module chunks = 0